/** 音楽画面で共通に使う定数 */

/** Apple Music のアクセントカラー */
export const ACCENT_COLOR = '#fa243c'

/** 音楽ライブラリは Apple Music 由来の m4a のみを扱う */
export const MUSIC_DOMAIN = 'apple_music'
export const MUSIC_MIME_TYPE = 'audio/mp4'

/** 一覧画面をダウンロード済みのみに絞るクエリ */
export const DOWNLOADED_ONLY_PARAM = 'downloaded'
export const DOWNLOADED_ONLY_QUERY = `${DOWNLOADED_ONLY_PARAM}=1`

/** アルバム詳細を開いた直後に再生する曲を指定するクエリ（エピソード直リンクの接続先） */
export const AUTOPLAY_TRACK_PARAM = 'track'

/** 曲一覧はクライアント側で並べ替え・検索するため、全件まとめて取得する */
export const TRACK_FETCH_LIMIT = 10000
